const setHeaderHight = () => {
	const header = document.querySelector('.shopify-section-group-header-group');
	document.body.style.setProperty('--header', header.offsetHeight + 'px');
};
document.addEventListener('DOMContentLoaded', setHeaderHight);
window.addEventListener('scroll', setHeaderHight);

const toggleLocalSelector = () => {
	const wrapper = document.querySelector('.has-local-selector [data-disclosure-toggle]');
	if (wrapper === null) {
		return;
	}
	wrapper.addEventListener('click', () => {
		wrapper.classList.toggle('is-open');
	});
};
document.addEventListener('DOMContentLoaded', toggleLocalSelector);

const setPoliciesHeadingClass = () => {
	if (!location.pathname.includes('policies')) {
		return;
	}

	document.querySelector('.shopify-policy__title').classList.add('content-header');
};
document.addEventListener('DOMContentLoaded', setPoliciesHeadingClass);